import "./App.css";
const phone = "073374 82255";
const tel = "tel:+917337482255";
const whatsapp = "https://wa.me/917337482255";
const map = "https://maps.app.goo.gl/vrnQMocZazGxh4kj8";
const logo = "https://souanluxuryspa.com/wp-content/uploads/2023/10/logo-e1696572880167.png";
const heroImage = "https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&w=1400&q=80";
const ambienceImage = "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&w=1200&q=80";
const therapyImage = "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?auto=format&fit=crop&w=1200&q=80";
const jacuzziImage = "https://lh3.googleusercontent.com/p/AF1QipOLLCbBUxs96nQSVK53R6_t7A0kelY_hJwARJR5=s680-w680-h510-rw";
const roomImage = "https://lh3.googleusercontent.com/p/AF1QipNt2CVlE-3AR8ftYlOv-OwhsOzAGokbynEg28ge=s680-w680-h510-rw";

const services = [
  {
    title: "Deep Tissue Massage",
    desc: "Targets deep muscle tension, chronic pain & body stiffness — most booked massage in Hyderabad",
    image: therapyImage,
  },
  {
    title: "Swedish Massage",
    desc: "Gentle, full-body relaxation therapy perfect for first-time spa visitors in Hyderabad",
    image: heroImage,
  },
  {
    title: "Aromatherapy",
    desc: "Healing essential oil massage therapy for mental stress and physical fatigue relief",
    image: ambienceImage,
  },
  {
    title: "Balinese Massage",
    desc: "Traditional combination massage technique for deep, restorative full-body relaxation",
    image: roomImage,
  },
  {
    title: "Hot Stone Therapy",
    desc: "Warm stone massage that relieves stiffness, improves circulation and eases tension",
    image: therapyImage,
  },
  {
    title: "Jacuzzi Bath",
    desc: "Premium hydrotherapy experience — the ultimate spa luxury in Hyderabad",
    image: jacuzziImage,
  },
];

const reasons = [
  "Same-day spa booking available in Hyderabad",
  "Prime location — easily accessible from all areas of Hyderabad",
  "Spotless, premium private spa rooms",
  "Certified, professional massage therapists",
  "Best spa deals and offers in Hyderabad",
  "Affordable luxury spa experience in Hyderabad",
  "Rated among the top massage centers in Hyderabad",
];

const reviews = [
  {
    name: "Happy Priya R., Hyderabad",
    text: "Hands down the best spa in Hyderabad. The deep tissue massage was incredible — clean rooms, professional staff, and very calming atmosphere.",
  },
  {
    name: "Kiran M., Repeat Customer",
    text: "Booked same day and got an instant slot. Best massage center in Hyderabad — easy to find near Metro Pillar C1666 and very affordable with the offers.",
  },
  {
    name: "Sneha T., Weekend Visitor",
    text: "Best spa in Hyderabad for stress relief, no doubt. The Swedish massage and aromatherapy combo was exactly what I needed. Highly recommend!",
  },
];

function App() {
  return (
    <div className="min-h-screen bg-[#f7f2eb] text-stone-900">
      <header className="sticky top-0 z-50 border-b border-stone-200/80 bg-white/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 lg:px-8">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-amber-700">
              Luxury Spa in Hyderabad
            </p>
            <h1 className="text-lg font-bold sm:text-xl">
              Booking Available with Instant Discount
            </h1>
          </div>
          <div className="hidden items-center gap-3 sm:flex">
            <a
              href={whatsapp}
              className="rounded-2xl border border-stone-300 bg-white px-4 py-2 text-sm font-semibold text-stone-700 hover:bg-stone-100"
            >
              WhatsApp
            </a>
            <a
              href={tel}
              className="rounded-2xl bg-stone-900 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:opacity-90"
            >
              Call Now
            </a>
          </div>
        </div>
      </header>

      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={heroImage}
            alt="Luxury spa ambiance"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#41180C]/10 via-[#41180C]/10 to-[#41180C]/10" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#41180C]/10 to-transparent" />
        </div>

        <div className="relative mx-auto grid max-w-7xl gap-10 px-4 py-14 text-white lg:grid-cols-[1.1fr_0.9fr] lg:px-8 lg:py-24">
          <div className="max-w-2xl">
            <a href="http://jubileehills.souanluxuryspa.com/">
              <img
                src={logo}
                alt="Souan Luxury Spa Logo"
                className="h-24 w-30 mb-3"
              />
            </a>
            <div className="mb-5 inline-flex items-center rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-xs font-medium tracking-wide text-stone-100 shadow-sm backdrop-blur">
              Best Spa in Hyderabad • Same Day Booking Available • Upto 30% Off
            </div>
            <h2 className="text-4xl font-extrabold leading-tight sm:text-5xl lg:text-6xl">
              Best Luxury Spa in Jubilee Hills - Hyderabad - Upto 30% Off on Premium Massage
              Services
            </h2>
            <p className="mt-5 max-w-xl text-base leading-7 text-stone-200 sm:text-lg">
              Looking for the <b>best spa in Hyderabad?</b> Souan Luxury Spa is
              Hyderabad's most trusted destination for premium massage therapy
              and full body relaxation. Whether you need a{" "}
              <b>deep tissue massage</b>, a calming <b>aromatherapy session</b>,
              or a complete
              <b>spa day in Hyderabad</b> — we've got you covered. Enjoy up to
              30% off on all services, with same-day spa booking available right
              now. Hyderabad — we've got you covered. Enjoy <b>up to 30% off</b>{" "}
              on all services, with <b>same-day spa booking</b> available right
              now.
            </p>
            <div className="mt-7 grid gap-3 sm:grid-cols-3">
              <div className="rounded-2xl border border-white/15 bg-white/10 p-4 backdrop-blur-md">
                <p className="text-xs uppercase tracking-[0.2em] text-stone-300">
                  Open Daily
                </p>
                <p className="mt-1 text-lg font-bold">9 AM – 10 PM</p>
              </div>
              <div className="rounded-2xl border border-white/15 bg-white/10 p-4 backdrop-blur-md">
                <p className="text-xs uppercase tracking-[0.2em] text-stone-300">
                  Location
                </p>
                <p className="mt-1 text-lg font-bold">
                  Jubilee Hills - Hyderabad
                </p>
              </div>
              <div className="rounded-2xl border border-white/15 bg-white/10 p-4 backdrop-blur-md">
                <p className="text-xs uppercase tracking-[0.2em] text-stone-300">
                  Best For
                </p>
                <p className="mt-1 text-lg font-bold">Instant Phone Bookings</p>
              </div>
            </div>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href={tel}
                className="inline-flex items-center justify-center rounded-2xl bg-white px-6 py-4 text-base font-bold text-stone-900 shadow-lg transition hover:translate-y-[-1px]"
              >
                📞 Call Now for Instant Slot
              </a>
              <a
                href={whatsapp}
                className="inline-flex items-center justify-center rounded-2xl border border-white/20 bg-white/10 px-6 py-4 text-base font-bold text-white backdrop-blur transition hover:bg-white/15"
              >
                💬 WhatsApp Booking
              </a>
            </div>
          </div>

          <div className="lg:pl-8">
            <div className="overflow-hidden rounded-[2rem] border border-white/15 bg-white/95 text-stone-900 shadow-2xl backdrop-blur">
              <img
                src={ambienceImage}
                alt="Spa room interior"
                className="h-56 w-full object-cover"
              />
              <div className="p-6">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    {/* <p className="text-sm font-semibold uppercase tracking-[0.2em] text-amber-700">Why this page converts</p> */}
                    <h3 className="mt-2 mb-2 text-2xl font-extrabold">
                      Why Souan Luxury Spa is the Best Spa in Hyderabad
                    </h3>
                    <p className="text-sm text-black">
                      Thousands of customers across Hyderabad trust Souan Luxury
                      Spa for premium relaxation, certified massage therapy, and
                      unbeatable spa deals in Hyderabad.
                    </p>
                  </div>
                  {/* <div className="rounded-full bg-emerald-100 px-3 py-1 text-sm font-semibold text-emerald-700">High Intent</div> */}
                </div>
                <div className="mt-6 grid gap-3">
                  {[
                    "Instant same-day spa booking in Hyderabad",
                    "Prime location — Metro Pillar C1666, heart of Hyderabad",
                    "Full body massage, deep tissue & Swedish massage available",
                    "Up to 30% off on all massage therapy services",
                    "Clean, hygienic, and fully private spa rooms",
                    "Certified and experienced massage therapists in Hyderabad",
                    "Easy mobile-friendly booking - call or WhatsApp",
                  ].map((item) => (
                    <div
                      key={item}
                      className="rounded-2xl border border-stone-200 bg-stone-50 px-4 py-3 text-sm font-medium text-stone-700"
                    >
                      {item}
                    </div>
                  ))}
                </div>
                <div className="mt-6 rounded-2xl bg-[#41180C] p-5 text-white">
                  <p className="text-sm text-stone-300">Direct booking line</p>
                  <a
                    href={tel}
                    className="mt-1 block text-2xl font-extrabold tracking-wide hover:underline"
                  >
                    {phone}
                  </a>
                  <p className="mt-2 text-sm text-stone-300">
                    Book the best spa experience in Hyderabad today — limited
                    offer, don't miss out
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-[1.02fr_0.98fr]">
          <div>
            {/* <p className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">Why customers choose us</p> */}
            <h3 className="mt-3 text-3xl font-extrabold">
              Real Relief. Real Relaxation. Right Here in Hyderabad
            </h3>
            <p className="mt-4 max-w-2xl text-base leading-7 text-stone-600">
              Whether you're dealing with stress, chronic muscle tension, or
              just need a well-deserved break — Souan Luxury Spa Hyderabad is
              where the city comes to truly feel better. As the most trusted
              massage spa in Hyderabad, we make it easy to book a full body
              massage in Hyderabad, walk in the same day, and leave completely
              refreshed.
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-1">
              {reasons.map((item) => (
                <div
                  key={item}
                  className="rounded-[1.5rem] border border-stone-200 bg-white p-5 shadow-sm"
                >
                  <div className="text-lg font-bold">✓ {item}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="overflow-hidden rounded-[2rem] border border-stone-200 bg-white shadow-sm">
            <img
              src={roomImage}
              alt="Premium massage room"
              className="h-72 w-full object-cover"
            />
            <div className="p-6">
              {/* <p className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">Quick details</p> */}
              <h4 className="mt-2 text-2xl font-extrabold">
                Book the Best Spa in Hyderabad — Right Now
              </h4>
              <div className="mt-6 space-y-4 text-sm leading-7 text-stone-700">
                <div className="rounded-2xl bg-stone-50 p-4">
                  <strong>Phone:</strong> {phone}
                </div>
                <div className="rounded-2xl bg-stone-50 p-4">
                  <strong>Timings:</strong> Open daily from 9:00 AM to 10:00 PM
                </div>
                <div className="rounded-2xl bg-stone-50 p-4">
                  <strong>Address:</strong> Metro Pillar C1666, Road No. 36, above Manyavar, CBI Colony, Jubilee Hills, Hyderabad, Telangana 500033
                </div>
                <div className="rounded-2xl bg-stone-50 p-4">
                  <strong>Special Offer:</strong> Up to 30% Off on All Massage &
                  Spa Services in Hyderabad
                </div>
              </div>
              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <a
                  href={tel}
                  className="inline-flex flex-1 items-center justify-center rounded-2xl bg-[#41180C] px-5 py-4 font-bold text-white hover:opacity-90"
                >
                  Call Now
                </a>
                <a
                  href={map}
                  className="inline-flex flex-1 items-center justify-center rounded-2xl border border-stone-300 px-5 py-4 font-bold text-stone-800 hover:bg-stone-50"
                >
                  Get Directions
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="border-y border-stone-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-16 lg:px-8">
          <div className="max-w-2xl">
            <p className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">
              Popular therapies
            </p>
            <h3 className="mt-3 text-3xl font-extrabold">
              Best Massage Therapies in Hyderabad — All Under One Roof
            </h3>
            <p className="mt-4 text-base leading-7 text-stone-600">
              Souan Luxury Spa offers Hyderabad's most complete range of
              professional massage therapies. Every service is available at up
              to 30% off — making us the most affordable luxury spa in
              Hyderabad.
            </p>
          </div>
          <div className="mt-8 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
            {services.map((service) => (
              <div
                key={service.title}
                className="overflow-hidden rounded-[1.75rem] border border-stone-200 bg-stone-50 shadow-sm"
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="h-52 w-full object-cover"
                />
                <div className="p-6">
                  <h4 className="text-xl font-bold">{service.title}</h4>
                  <p className="mt-3 text-sm leading-7 text-stone-600">
                    {service.desc}
                  </p>
                  <a
                    href={tel}
                    className="mt-5 inline-flex rounded-xl bg-[#41180C] px-4 py-2 text-sm font-bold text-white hover:opacity-90"
                  >
                    Call for Availability
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-2">
          <div className="overflow-hidden rounded-[2rem] bg-[#41180C] text-white shadow-lg">
            <img
              src={jacuzziImage}
              alt="Jacuzzi and relaxation setup"
              className="h-72 w-full object-cover opacity-80"
            />
            <div className="p-8">
              <p className="text-sm font-semibold uppercase tracking-[0.25em] text-stone-300">
                Trust block
              </p>
              <h3 className="mt-3 text-3xl font-extrabold">
                What Hyderabad Clients Say About Souan Luxury Spa
              </h3>
              <div className="mt-6 space-y-2 text-sm leading-7 text-stone-200">
                <p>
                  Customers consistently highlight our clean, well-maintained
                  rooms, professional therapists, and a calm, premium atmosphere
                  that helps them truly relax.
                </p>
                <p>
                  Many visitors choose us for quick, same-day bookings and easy
                  accessibility near Metro Pillar C1666, making it convenient for both
                  planned visits and last-minute appointments.
                </p>
                <p>
                  From deep tissue relief to soothing aromatherapy, clients
                  appreciate the variety of therapies and the attention to
                  detail that makes each session feel worth it.
                </p>
              </div>
            </div>
          </div>

          <div>
            <h3 className="mt-3 text-3xl font-extrabold">
              What Our Clients Say About Us
            </h3>
            <div className="mt-6 grid gap-4">
              {reviews.map((review) => (
                <div
                  key={review.name}
                  className="rounded-[1.75rem] border border-stone-200 bg-white p-6 shadow-sm"
                >
                  <div className="text-lg">⭐⭐⭐⭐⭐</div>
                  <p className="mt-3 text-sm leading-7 text-stone-600">
                    “{review.text}”
                  </p>
                  <p className="mt-4 font-bold text-stone-800">{review.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#efe4d5]">
        <div className="mx-auto max-w-7xl px-4 py-16 lg:px-8">
          <div className="grid gap-8 lg:grid-cols-[0.95fr_1.05fr]">
            <div>
              <p className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">
                Visit Us Now
              </p>
              <h3 className="mt-3 text-3xl font-extrabold">
                Conveniently Located — Best Spa Near You in Hyderabad
              </h3>
              <p className="mt-4 text-base leading-7 text-stone-700">
                Finding a trusted spa near you in Hyderabad just got easier.
                Souan Luxury Spa is centrally located on Road No. 36,
                above Manyavar, CBI Colony, Jubilee Hills, Hyderabad. Find us near Metro Pillar C1666.
              </p>
              <div className="mt-6 rounded-[1.75rem] bg-white p-6 shadow-sm">
                <p className="text-sm text-stone-500">Address</p>
                <p className="mt-2 text-lg font-bold">
                  Metro Pillar C1666, Road No. 36, above Manyavar, CBI Colony, Jubilee Hills, Hyderabad, Telangana 500033
                </p>
                <p className="mt-3 text-sm leading-7 text-stone-600">
                  We rank for: "best spa near me Hyderabad" • "body massage
                  Hyderabad" • "massage center near Metro Pillar C1666 Hyderabad"
                </p>
                <div className="mt-5 flex flex-col gap-3 sm:flex-row">
                  <a
                    href={map}
                    className="inline-flex items-center justify-center rounded-2xl border border-stone-300 px-5 py-3 font-bold text-stone-800 hover:bg-stone-50"
                  >
                    Open in Maps
                  </a>
                  <a
                    href={tel}
                    className="inline-flex items-center justify-center rounded-2xl bg-[#41180C] px-5 py-3 font-bold text-white hover:opacity-90"
                  >
                    Call Before Visit
                  </a>
                </div>
              </div>
            </div>

            <div className="overflow-hidden rounded-[2rem] bg-white shadow-sm">
              <img
                src={therapyImage}
                alt="Spa therapy experience"
                className="h-72 w-full object-cover"
              />
              <div className="p-8">
                <p className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">
                  Your Visit Made Simple
                </p>
                <h3 className="mt-3 text-3xl font-extrabold">
                  Relaxation Starts the Moment You Reach Us
                </h3>
                <ol className="mt-6 space-y-2 text-sm leading-7 text-stone-700">
                  <li>
                    <strong>1.</strong> Conveniently situated on Road No. 36 near Metro Pillar C1666, making it quick to reach from anywhere in the city.
                  </li>
                  <li>
                    <strong>2.</strong> Well-maintained rooms, soothing
                    interiors, and a peaceful setup that helps you unwind
                    instantly.
                  </li>
                  <li>
                    <strong>3.</strong> Trained experts who understand body
                    relaxation, pressure points, and personalized care.
                  </li>
                  <li>
                    <strong>4.</strong> Call or WhatsApp for instant slot
                    confirmation, or visit directly for same-day service.
                  </li>
                  <li>
                    <strong>5.</strong> From Deep Tissue and Swedish to
                    Aromatherapy and Jacuzzi sessions — choose what suits your
                    need.
                  </li>
                  <li>
                    <strong>6.</strong> From Deep Tissue and Swedish to
                    Aromatherapy and Jacuzzi sessions — choose what suits your
                    need.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 lg:px-8">
        <div className="overflow-hidden rounded-[2rem] bg-gradient-to-r from-[#41180C] via-[#41180C] to-[#41180C] shadow-xl">
          <div className="grid lg:grid-cols-[1.15fr_0.85fr]">
            <div className="p-8 text-white lg:p-12">
              <p className="text-sm font-semibold uppercase tracking-[0.25em] text-stone-300">
                Relax More. Pay Less. Feel Better.
              </p>
              <h3 className="mt-3 text-3xl font-extrabold sm:text-4xl">
                Book the Best Spa in Hyderabad Today — Limited Slots Available
              </h3>
              <p className="mt-4 max-w-2xl text-base leading-7 text-stone-200">
                Don't miss Hyderabad's best spa deal. Visit Souan Luxury Spa
                Hyderabad and enjoy a world-class full body massage, deep tissue
                therapy, or aromatherapy session — all at up to 30% off.
                Same-day bookings available. Call now and secure your slot at
                the #1 luxury spa in Hyderabad.
              </p>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <a
                  href={tel}
                  className="inline-flex items-center justify-center rounded-2xl bg-white px-6 py-4 text-base font-bold text-stone-900 hover:translate-y-[-1px]"
                >
                  📞 Call Now
                </a>
                <a
                  href={whatsapp}
                  className="inline-flex items-center justify-center rounded-2xl border border-white/20 bg-white/10 px-6 py-4 text-base font-bold text-white hover:bg-white/15"
                >
                  💬 WhatsApp Us
                </a>
              </div>
            </div>
            <div className="min-h-[260px] lg:min-h-full">
              <img
                src={ambienceImage}
                alt="Elegant spa space"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <footer className="border-t border-stone-200 bg-white">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-6 text-sm text-stone-500 sm:flex-row sm:items-center sm:justify-between lg:px-8">
          <p>
            © 2026 Souan Luxury Spa Hyderabad. All rights reserved. Designed By{" "}
            <a href="https://kishkindhamedia.com/">Kishkindha Media</a>
          </p>
        </div>
      </footer>

      <div className="fixed inset-x-0 bottom-0 z-50 border-t border-stone-200 bg-white/95 p-3 shadow-2xl backdrop-blur sm:hidden">
        <div className="mx-auto flex max-w-lg gap-3">
          <a
            href={tel}
            className="flex-1 rounded-2xl bg-[#41180C] px-4 py-4 text-center text-base font-bold text-white"
          >
            📞 Call Now
          </a>
          <a
            href={map}
            className="flex-1 rounded-2xl border border-stone-300 px-4 py-4 text-center text-base font-bold text-stone-800"
          >
            📍 Visit Store
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
